import { useEffect, useState, useRef } from 'react'
import { Modal, message, Drawer, Checkbox, Select } from 'antd'
import { CloseOutlined, DownOutlined, UpOutlined, DeleteOutlined, CloseCircleOutlined } from '@ant-design/icons';
import style from './index.module.scss'
import * as apis from '../../api/networkDisk'
import useStore from '../../store/useStore'
import { deepCopy } from '../../util';
import { StorageModule } from "../../modules/storage";
import TaskTagPop from '../../components/memos/taskTagPop';
import MarkDownPop from '../../components/memos/markDownPop';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import ImgPreview from '../../components/memos/imgPreview'
import { async } from '@antv/x6/lib/registry/marker/async';

interface Props {
    visible: any
    onClose?: () => void;
    onRefresh?: () => void;
    onClick?: (i: any) => void;
    styleCss?: any
}

const TagMetaMenu = (props: Props) => {
    const taskList = useRef<any>([]);
    const [userInfo, setUserInfo] = useState<any>();
    const [taskVisible, setTaskVisible] = useState<boolean>(false);
    const [markDownVisible, setMarkDownVisible] = useState<boolean>(false);
    const [tagMeta, setTagMeta] = useState<any>([]);
    const [replacementMeta, setReplacementMeta] = useState<any>([]);

    //点击所选的标签
    //点击所选标签的类别
    const [chooseLabelTagKey, setChooseLabelTagKey] = useState<any>(null);

    const { store, dispatch } = useStore();
    const selectRef = useRef<any>()

    useEffect(() => {
        if (store.tagMeta.length == 0) {
            // getTagMeta()
        } else {

            setTagMeta(deepCopy(store.tagMeta))
            setReplacementMeta(deepCopy(store.tagMeta.filter((i: any) => i.type == 'replacement')))
        }
    }, [store.tagMeta,])
    useEffect(() => {
        if (props.visible) {
            // getTagMeta()
            dispatch({
                type: 'GET_TAGMETA',
            });
            setUserInfo(StorageModule.getUser().user);
        }
    }, [props.visible])
    useEffect(() => {
        console.log(store.tagMeta, store.showTagMeta)
        setTagMeta(store.tagMeta.filter((i: any) => store.showTagMeta.toString().indexOf(i.type) > -1))
        setReplacementMeta(deepCopy(store.tagMeta.filter((i: any) => i.type == 'replacement')))
    }, [store.showTagMeta])

    const options = [
        { label: '业务标签', value: 'attachment' },
        { label: '格式标签', value: 'replacement' },
        { label: '分类标签', value: 'classifier' },
    ];
    const taskTab = (i: any) => {
        let info: any = {}
        if (i.name === '任务计划') {
            info = { ...i, label1: '计划完成时间', label2: '预计工时' }
        } else if (i.name === '开始执行') {
            info = { ...i, label1: '预计完成时间', label2: '预计工时' }
        }
        else if (i.name === '任务完成') {
            info = { ...i, label1: '实际完成时间', label2: '实际工时' }
        }
        else if (i.name === '版本计划') {
            info = { ...i, label1: '版本号', }
        }
        else {
            info = { ...i, }
        }
        dispatch({
            type: 'SET_SELECTTAGMETA',
            data: info
        });
    }
    const getTagMeta = async (data?: any) => {
        try {
            let res: any = await apis.tagMeta()
            if (res.ok) {
                dispatch({
                    type: 'SET_TAGMETA',
                    data: res.data
                });
                dispatch({
                    type: 'SET_SHOWNODE',
                    data: false
                });
            }
        } catch {

        }
    }
    //标签弹出框类型
    const labelPop = (mimeType: any) => {
        console.log('labelPop', store.tagMeta, mimeType)
        dispatch({
            type: 'SET_LABELPOP',
            data: true
        });

        // let _taskList = store.tagMeta.filter((i: any) => i.mimeType === mimeType)
        // console.log(_taskList)
        // if (mimeType === 'text/markdown') {
        //     setMarkDownVisible(true)
        // } else if (mimeType === 'image/*') {
        //     taskTab({ ..._taskList[0] })
        //     setTaskVisible(true)
        // } else if (mimeType === 'image/m2ni-img-notas') {
        //     taskTab({ ..._taskList[0] })
        //     setTaskVisible(true)
        // } else {
        //     // setMemoModal(true)
        // }
    }
    const checkStickLabelTag = (labelTagKey: any, i?: any) => {
        console.log(i)
        if (JSON.stringify(store.memoInfo) != '{}' && store.memoInfo?.data?.id) {
            setChooseLabelTagKey(labelTagKey)
        } else {
            setChooseLabelTagKey(null)
            message.warning('请选择并且只能选一个便签')
        }

    }
    const stickLabelTag = async (meta: any, i?: any) => {
        console.log(meta, i)
        let res: any = await apis.putMemoNotation(store.memoInfo.data.id, "LabelTag", {
            catalogue: meta.catalogue,
            markValue: meta.markValue,
            createBy: meta.createBy
        })
        setChooseLabelTagKey(null)


    }
    const openTask = (i: any) => {
        // if ((window as any).graphItem?.getSelectedCells().length == 1) {
        console.log('openTask',i,store.memoInfo)
        if (JSON.stringify(store.memoInfo) != '{}' && store.memoInfo?.data?.id) {
            console.log(i)
            let isOwn: any = store.memoInfo.data.ownerId === userInfo.id
            console.log(isOwn, store.subjectInfo, store.memoInfo)
            taskTab(i)
            if (i.notation === 'MarkdownTag' || i.notation === 'ImageTag' || i.notation === 'ImgNotesTag') {
                if ((!isOwn && store.subjectInfo.data.users?.length == 0) || (!isOwn && !store.subjectInfo.data.users)) {
                    message.warning('只能操作自己的markdown格式/图片格式/图片标注类型的便签')
                } else {
                    labelPop(i.mimeType)
                }
            } else {
                dispatch({
                    type: 'SET_TASKVISIBLE',
                    data: true
                });
                // setTaskVisible(true)
            }
        } else {
            message.warning('请选择并且只能选一个便签')
        }

    }
    const onCheckChange = (checkedValues: CheckboxValueType[]) => {
        console.log('checked = ', checkedValues, checkedValues.toString());
        dispatch({
            type: 'SET_SHOWTAGMETA',
            data: checkedValues
        });

    };
    const delMemoNotation = async (item: any,) => {
        console.log(item)
        let res: any = await apis.delMemoNotation(item.id, 'LabelTag',)
        if (res.ok) {
            getTagMeta()
        }
    }
    return (
        <>
            <>
                {props.visible && <div className='CLOSESHOWALL'>
                </div>}</>
            <>{props.visible && <div className={style.taskMenu} style={props.styleCss && props.styleCss} data-flex='dir:top main:justify '
            >
                <div>
                    <div style={{ overflow: 'auto' }}>
                        <div data-flex='main:right cross:top' style={{ width: '100%' }} className={style.drawerTitle + ' mb-10'}><CloseCircleOutlined onClick={() => { props.onClose && props.onClose() }} /></div>
                        {
                            tagMeta.map((i: any, index: any) => {
                                return (
                                    <>{i.notation != 'LabelTag' ? <>{i.type == 'attachment' && <div key={index} className={style.taskMenu_item + `${i.type == 'attachment' ? ` item${index + 1}` : ' item-common'} `} onClick={() => {
                                        // taskTab(i)
                                        dispatch({
                                            type: 'SET_CNODE',
                                            data: i
                                        });
                                        openTask(i)

                                        props.onClick && props.onClick(i)
                                    }}>{i.name}</div>}</> :
                                        <>
                                            {
                                                Object.keys(i.catalogues).map((key) => (
                                                    <div key={index + key} className='pos-r' >
                                                        {/* <>{console.log(key, i.catalogues[key])}</> */}
                                                        <> <div data-flex='main:justify cross:center ' className={style.taskMenu_item + ' item-common'}
                                                            onClick={() => {
                                                                checkStickLabelTag(key)
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                setChooseLabelTagKey(null)
                                                            }}
                                                        ><div>{key}  </div>
                                                            {chooseLabelTagKey == key ? <UpOutlined className='  f12 mr-10' /> :
                                                                <DownOutlined className='  f12 mr-10' />}
                                                            <Select
                                                                ref={selectRef}
                                                                open={chooseLabelTagKey == key}
                                                                key={'catalogues' + key}
                                                                style={{ width: 120 }}
                                                                dropdownRender={() => (
                                                                    <div className='labelTag-list'>
                                                                        {i.catalogues[key].map((item: any, idx: any) => {
                                                                            return (<div data-flex="main:justify cross:center" className='labelTag-list-item '>
                                                                                <div style={{ flex: "0 0 80%" }}
                                                                                    onClick={() => {
                                                                                        stickLabelTag(item, key)
                                                                                    }}
                                                                                >{item.markValue}</div>
                                                                                <DeleteOutlined onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    e.preventDefault();
                                                                                    delMemoNotation(item)
                                                                                }} className={`icon_delete icon_hover  `} /></div>)
                                                                        })}
                                                                    </div>
                                                                )}
                                                                onMouseLeave={(e) => {
                                                                    // selectRef.current.blur()
                                                                    // console.log('onMouseLeave', selectRef.current)
                                                                }}
                                                                onChange={(e: any, $event: any) => {
                                                                    console.log($event)
                                                                    // stickLabelTag($event, key)
                                                                    // e.preventDefault();
                                                                    // e.stopPropagation();
                                                                }}
                                                                fieldNames={
                                                                    { label: 'markValue', value: 'id' }
                                                                }
                                                                options={i.catalogues[key]} /></div></>
                                                    </div>
                                                ))
                                            }
                                        </>}</>)
                            }
                            )
                        }
                    </div>
                    <div className="pos-r">
                        <div data-flex='main:justify cross:center ' className={style.taskMenu_item + ' item-common'} onClick={() => {
                            checkStickLabelTag('格式')
                        }}
                            onMouseLeave={(e) => {
                                setChooseLabelTagKey(null)
                            }}>
                            格式
                            {chooseLabelTagKey == '格式' ? <UpOutlined className='  f12 mr-10' /> :
                                <DownOutlined className='  f12 mr-10' />}
                            <Select
                                key={'replacement'}
                                style={{ width: 120 }}
                                open={chooseLabelTagKey == "格式"}
                                dropdownRender={() => (
                                    <div className='labelTag-list'>
                                        {replacementMeta.map((item: any, idx: any) => {
                                            return (<div data-flex="main:justify cross:center" className='labelTag-list-item '>
                                                <div style={{ flex: "0 0 80%" }}
                                                    onClick={() => {
                                                        // taskTab(i)
                                                        dispatch({
                                                            type: 'SET_CNODE',
                                                            data: item
                                                        });
                                                        openTask(item)

                                                        props.onClick && props.onClick(item)
                                                    }}
                                                >{item.name}</div>
                                            </div>)
                                        })}
                                    </div>
                                )}
                                onMouseLeave={(e) => {
                                }}
                                onChange={(e: any, $event: any) => {
                                }}
                                fieldNames={
                                    { label: 'name', value: 'id' }
                                }
                                options={replacementMeta} />
                        </div>
                    </div>
                </div>
                <Checkbox.Group options={options} defaultValue={store.showTagMeta} onChange={onCheckChange} />
                {/* </Drawer> */}

            </div>}
                {/* <TaskTagPop /> */}
                {/* <MarkDownPop /> */}
                <ImgPreview />
            </>
        </>
    )
}

export default TagMetaMenu